import axios from "axios";

const BASEURL = process.env.REACT_APP_API_KEY;

//Gets the token that will be used in the header of every call in the portal
export const getPortalToken = async (sessionId) => {
  try {
    const response = await axios.get(
      `${BASEURL}SessionManager/token/${sessionId}`
    );
    return response.data;
  } catch (err) {
    return err.response;
  }
};
//start the signature procedure on IDSign
export const startSign = async (token, key1, key2) => {
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = { sessionId: key1, signatoryId: key2 };
  try {
    const response = await axios.post(
      `${BASEURL}Sign/startsign`,
      body,
      headers
    );
    return response;
  } catch (err) {
    return err.response;
  }
};

export const getSummaryInfo = async (token, key1, key2, key3) => {
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const body = { sessionId: key1, signatoryId: key2, isReturn: key3 };
  try {
    const response = await axios.post(
      `${BASEURL}SessionManager/summaryinfo`,
      body,
      headers
    );
    return response;
  } catch (err) {
    return err.response;
  }
};
